import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceBase } from 'app/shared/infrastructure';
import { OrderApiConfiguration } from '../order-api-configuration';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})

export class DoctorFeesTaxService extends ServiceBase {

    private actionUrl: string;

    constructor(private _http: HttpClient, private _configuration: OrderApiConfiguration) {
        super();
        this.actionUrl = _configuration.server;
    }

   
    sendDoctorFeesToTax = (payload: any): Observable<any[]> => {
        return this._http.post<any>(`${this.actionUrl}DoctorFeesTax/SendDoctorFeesToTax`, payload);
    }
}